import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Icon, Input } from "antd";
import { connect } from "react-redux";
import { AutoResizeTextArea } from "../../components/AutoResizeTextArea";

import SearchBar from "../../components/SearchBar";
import PaginationAds from "../../components/PaginationAds";
import { AllTypeCategory, AdType, ButtonType, LinkTargetEnum } from "../../models";
import {
  selectFavorites,
  getFavorites,
  selectFavoriteIds,
  removeFavorite,
  selectIsLoadingFavorites,
  startLoadingFavorites
} from "../../routes/Favorite/favorite.ducks";
import { selectLoadedUser } from "../../routes/Auth/auth.ducks";
import { selectModules } from "../App/selectors";
import { api, checkEmptyObject, getWindowWidth, isMobileScreen, notification } from "../../services";
import styles from "./styles.scss";
import LeftMenu from "../../components/LeftMenu";
import getWidthContext from "../../HOCs/getWidthContext";
import HelmetComponent from "../../utils/HelmetHelper";
import { requireUserLogin } from "../../routes/Auth";
import confirmModal from "../../services/confirmModal";
import { max } from "moment";

function FavoritePage(props: any) {
  const {
    user,
    ads,
    favoriteIds,
    getFavorites,
    removeFavorite,
    modules,
    match: { path },
    showHeaderLogoAndSearchBarHandler,
    isLoadingFavorites
  } = props;

  const [selectedModule, setSelectedModule] = useState(undefined);
  const [page, setPage] = useState(1);
  const formRef = useRef(null);
  const confirmModalContainer = useRef(null);
  useEffect(() => {
    showHeaderLogoAndSearchBarHandler;
    checkEmptyObject(user) && loadFavorites(props, user);
  }, [user]);

  useEffect(() => {
    /**
     * TODO: Davor - remove in future, tempfix due to lagging of favoriteIds backend
     * await on favDelete duck didnt help
     * endpoint returns mismatch of count and data properties in response on higher delete /get requests rate
    **/
    // const timeout = setTimeout(() => {
    checkEmptyObject(user) && loadFavorites(
      props,
      user,
      selectedModule,
      page
    );
    //}, 1000);
    //return () => clearTimeout(timeout);
  }, [favoriteIds, user]);

  useEffect(() => {
    if (ads && ads.page > 1 && ads.data.length === 0) {
      loadFavorites(props, undefined, selectedModule, page - 1);
    }
  }, [JSON.stringify(ads)]);



  const RenderNoteForm = Form.create()(
    (props: any) => {
      const { form, formRef, ad } = props;
      const isMobile = isMobileScreen(getWindowWidth());
      formRef.current = form;

      useEffect(() => {
        form.setFieldsValue({
          note: ad.note || ""
        });
      }, [ad.note]);

      return (
        <Form>
          <p>Ovdje možeš unijeti svoje bilješke vezane uz ovaj oglas. Samo ti vidiš unijetu bilješku.<br /><br /></p>
          <Form.Item>
            {form.getFieldDecorator("note", {
              rules: [
                {
                  max: 500,
                  message: "Bilješka ne smije biti duža od 500 znakova."
                }
              ],
            })(
              <AutoResizeTextArea
                autoFocus={true}
                placeholder="Unesi svoju bilješku"
                rows={isMobile ? 3 : 9}
                className={styles.noteInput}
              />
            )}

            <span className={styles.noteLengthIndicator}>
              {form.getFieldValue("note") ? form.getFieldValue("note").length : 0} / 500
            </span>
          </Form.Item>

          <Form.Item style={{ display: "none" }}>
            {/* Hidden field to store adId */}

            {form.getFieldDecorator("adId", {
              initialValue: ad.id,
              rules: [
                {
                  required: true,
                  message: "AdId is required."
                }
              ],
            })(
              <Input type="hidden" />
            )}
          </Form.Item>
        </Form>
      );
    }
  );

  const onNoteFormSubmit = () => {
    formRef.current.validateFields((err: any, values: any) => {
      if (!err) {

        api.Favorite.note(values)
          .then(() => {
            // throw notification success
            notification.show("Bilješka spremljena");

            // Log the survey submission event


            // Destroy the confirm modal
            confirmModalContainer.current.destroy();
            loadFavorites(props, undefined, selectedModule, page);
          })
      }
    });
  }

  const onNoteFormCancel = (a) => {
    confirmModalContainer.current.destroy();
  }

  const loadFavorites = (
    props: any,
    userProfile?: any,
    module?: string,
    nextPage?: number
  ) => {
    const { user, favoriteIds } = props;

    if (favoriteIds) {
      getFavorites(
        favoriteIds,
        userProfile || user,
        module,
        nextPage
      );
    }
  };

  const handleDeleteClick = (adId: any) => {
    // Use removeFavorite directly - always DELETE since all items on this page are favorites
    removeFavorite(adId, favoriteIds, ads, user);
  };

  const handlePageChange = (nextPage: number) => {
    setPage(nextPage);
    loadFavorites(props, undefined, selectedModule, nextPage);
  };

  const handleModuleSearch = (value: string) => {
    if (value !== AllTypeCategory.name) {
      setSelectedModule(value);
      handleSubmit(value);
    } else {
      setSelectedModule(undefined);
      loadFavorites(props);
    }
  };

  const handleSubmit = (value: string) => {
    loadFavorites(props, undefined, value || selectedModule);
  };

  const handleNote = (e, ad: any) => {
    e.stopPropagation();
    e.preventDefault();
    const isMobile = isMobileScreen(getWindowWidth());

    confirmModalContainer.current = confirmModal.show({
      title: "Bilješka",
      iconType: "NaN",
      centered: !isMobile,
      style: isMobile ? { top: "0" } : {},
      footer: <React.Fragment>
        <Button
          type="default"
          className={styles.cancelButton}
          onClick={onNoteFormCancel}
        >
          Odustani
        </Button>
        <Button
          type="primary"
          className={styles.saveButton}
          onClick={onNoteFormSubmit}
        >
          Spremi
        </Button>
      </React.Fragment>,
      children: <RenderNoteForm formRef={formRef} ad={ad} />,
    });
  }

  const buttonComponents = [
    {
      role: ButtonType.top,
      component: "span",
      type: AdType.inActive,
      props: {
        onClick: handleDeleteClick,
        children: <Icon type="delete" className={styles.deleteIcon} />
      }
    }
  ];
  const searchBarActions = {
    // @ts-ignore
    onModuleSearch: (...params: any) => handleModuleSearch(...params)
  };

  return (
    <React.Fragment>
      <HelmetComponent
        title={`${"Spremljeni oglasi"} | ${"INDEX OGLASI"}`}
        ogTitle="Pogledajte spremljene oglase"
        index={false}
      />

      <LeftMenu activeKey={path}>
        <section className="favorite-page">
          {user || (
            !user &&
            ads &&
            ads.data &&
            ads.data.length > 0
          ) ? (
            <div className="page-title">{"Spremljeni oglasi"}</div>
          ) : null}
          <SearchBar
            module={selectedModule}
            modules={modules}
            adCount={ads && ads.count ? ads.count : 0}
            {...searchBarActions}
          />
          <div
            className={`child-center ${styles.adsContainer} ${user &&
              styles.leftEmptyText}`}
          >
            <PaginationAds
              ads={isLoadingFavorites ? undefined : ads}
              handlePageChange={handlePageChange}
              responsiveProps={{
                xs: 24
              }}
              adCardProps={{
                adLists: { favorites: ads },
                buttonComponents,
                hasFavorite: true,
                isCheckStatus: true,
                target: LinkTargetEnum.blank,
                handleNote: handleNote
              }}
              emptyAdsText={"Nema označenih favorita."}
              paginationClassName={styles.pagination}
              bottomSection={true}
              showGoogleAds={false}
            />
          </div>
        </section>
      </LeftMenu>
    </React.Fragment>
  );
}

FavoritePage.defaultProps = {
  ads: [],
  favoriteIds: [],
  user: null
};

const ConnectedFavoritePage = connect(
  (state: any) => ({
    ads: selectFavorites(state),
    user: selectLoadedUser(state),
    favoriteIds: selectFavoriteIds(state),
    modules: selectModules(state),
    isLoadingFavorites: selectIsLoadingFavorites(state)
  }),
  {
    getFavorites,
    removeFavorite,
    startLoadingFavorites
  }
)(getWidthContext(FavoritePage));

export default requireUserLogin(ConnectedFavoritePage);



// WEBPACK FOOTER //
// ./src/containers/FavoritePage/index.tsx